import React from 'react';
import styled from 'styled-components';
import { UnpaddedLayout, BareLayout } from 'components/Layout';
import Type from 'components/Type';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import * as tokens from 'styles';
import { useTranslation } from 'data/translation/useTranslation';
import themeFn, { Theme } from 'lib/theme';

const loaderColor = themeFn({
  fallback: tokens.black,
  duoLight: tokens.black,
  duoDark: tokens.black,
  familyLight: tokens.royalBlue,
  familyDark: tokens.black,
});

const LoaderWrapper = styled.div`
  position: absolute;
  top: calc(50% - 14px);
  width: 100%;
  text-align: center;
`;

const Loader = styled(LoadingIndicator)`
  & > circle {
    fill: ${loaderColor};
  }
`;

// minimum height so the loader is displayed properly on account pages
const Bare = styled(BareLayout)`
  min-height: 200px;
`;

const Text = styled(Type.P)`
  margin-top: ${tokens.spacer24};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

type ScreenProps = {
  headless?: boolean;
  theme: Theme;
  loadingText?: string;
};

const Screen = ({ headless, theme, loadingText }: ScreenProps) => {
  const Layout = headless ? Bare : UnpaddedLayout;
  const { t } = useTranslation();

  return (
    <Layout theme={{ mode: theme }}>
      <LoaderWrapper aria-live="polite" aria-label={t('loading_content')}>
        <Loader
          theme={{ mode: theme }}
          indicatorSize={LoadingIndicator.lg}
          aria-label={loadingText}
        />
        {loadingText && <Text>{loadingText}</Text>}
      </LoaderWrapper>
    </Layout>
  );
};

export default Screen;
